import { Navigate } from 'react-router-dom';
import { EstadoVazio } from '../componentes/ui';
import { useEmpresaCorrente } from '../hooks/useSessao';
import { Pagina } from './Carteira';

/**
 * Empresas, para quem não é admin: a **empresa escolhida** no topo.
 *
 * O sistema todo segue a empresa escolhida — o menu, as negociações, os
 * contratos. A primeira versão desta tela listava todas as empresas em que a
 * pessoa tem acesso, e quem entrava como uma via as outras: a resposta certa
 * para "ver outra empresa" é o "Trocar empresa", no topo. Aqui abre direto o
 * cadastro da escolhida — dados, conta bancária, documentos e, para o gestor,
 * os colaboradores.
 */
export function EmpresasDaParte(): JSX.Element {
  const empresa = useEmpresaCorrente();

  if (empresa === null) {
    return (
      <Pagina titulo="Empresas">
        <EstadoVazio
          titulo="Nenhuma empresa escolhida"
          descricao="Escolha a empresa em “Trocar empresa”, no topo da tela."
        />
      </Pagina>
    );
  }

  return <Navigate to={`/empresas/${empresa}`} replace />;
}
